import React from "react";

const Gap = ({ options, id }) => {
  const height = options?.height || 0;

  return <div id={id} style={{ height: `${height}px` }} />;
};

export default Gap;
